import React from "react";
import { Route, Routes } from "react-router-dom";
import { ChargeLayout } from "../components/chargeLayout";

export const ChargeRouters = () => {
  return (
    <Routes>
      <Route index element={<ChargeLayout />} />
    </Routes>
  );
};
